module.exports = __webpack_public_path__ + "img/logo-gitecx.3df09229.png";